(function ($)
{
	window.Comparison = function (sSymbol, sLabel, sColor) {
		this._inputData = {
			Symbol: sSymbol,
			Label: sLabel,
			Uid: InteractiveChart.GetGUID()
		};
		if (sColor) {
			this._inputData.Color = sColor;
		}
	};
	Comparison.prototype.Color = "#7499bc"; //Default
	Comparison.prototype.GetInputData = function ()
	{
		return this._inputData;
	};
	Comparison.prototype.SetColor = function (sColor) {
		this._inputData.Color = sColor;
	};
	Comparison.prototype.SetLabel = function (sLabel) {
		this._inputData.Label = sLabel;
	};
	Comparison.prototype.SetSymbol = function (sSymbol) {
		this._inputData.Symbol = sSymbol;
	};
	Comparison.prototype.GetInputData = function () {
		return this._inputData;
	};
})(jQuery);